define('GameDayCore/GDModel/ValueObjects/RealTimeHighlights/Highlight',['require','exports','module','../ValueObjectFactory','extant/extant','../../../GDUtil/resources/GDConfig','./RealTimeHighlightKeyword','../Resources/SmpteTimecode','./RealTimeHighlightsUrl','./RealTimeHighlightKeyword'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
        exists = require("extant/extant"),
        GDConfig = require("../../../GDUtil/resources/GDConfig"),
        RealTimeHighlightKeyword = require('./RealTimeHighlightKeyword'),
        SmpteTimecode = require('../Resources/SmpteTimecode'),
        RealTimeHighlightsUrl = require('./RealTimeHighlightsUrl');

	VO.create(Highlight);

	function Highlight($data) {
		var vo = VO.ensureVO(this, Highlight),
			data = $data,
	        keywords = parseKeywords(data),
	        dateUTC = parseDate(data),
	        urls = parseURLs(data),
	        thumbnails = parseThumbs(data),
	        defaultURL = establishDefaultURL(urls, GDConfig.supportedVideo);

        vo.id = data.id || "";
        vo.sv_id = keywords.sv_id || "";
        vo.keywords = keywords.list;
        vo.timecode = keywords.timecode || "";
        vo.dateUTC = dateUTC;
        vo.media_type = data["media-type"] || "";
        vo.headline = data.headline || "";
        vo.kicker = data.kicker || "";
        vo.headline = data.headline || "";
        vo.blurb = data.blurb || "";
        vo.duration = data.duration || "";
        vo.thumb = data.thumb._text || "";
        vo.thumbnails = thumbnails;
        vo.condensed = (data.condensed === "true");
        vo.urls = urls;
        vo.defaultURL = defaultURL;
        vo.getURLfromScenario = getURLfromScenarios;
        vo.getThumbByType = getThumbByType;
        vo.defaultThumb = getThumbByType(thumbnails, "44");
        vo.review = (data["media-type"] === "M" || data["media-type"] === "N");
        vo.statscast = (data["media-type"] === "S");
	}

	function parseKeywords($data) {
        var arr = [],
            keys = [].concat($data.keywords.keyword || []),
            key,
            sv_id,
            timecode,
            RealTimeHighlightKeyword = require("./RealTimeHighlightKeyword")

        for (var i = 0, long = keys.length; i < long; i++) {
            key = new RealTimeHighlightKeyword(keys[i]);
            arr.push(key);

            // set the sv_id if that is the prop we're lookin' at
            switch (key.type) {
                case "sv_id":
                    sv_id = key.value;
                    break;
                case "timecode_in":
                    timecode = new SmpteTimecode(key.value);
                    break;
            }
        }
        return {
            list : arr,
            sv_id  : sv_id,
            timecode : timecode
        };
    }

    function parseDate($data) {
        var dateStr = $data.date,
            splitResult = dateStr.split("T"),
            splitDate = splitResult[0].split("-"),
            splitTime = splitResult[1].substr(0, 8).split(":"),
            myDate = new Date(splitDate[0], splitDate[1], splitDate[2], splitTime[0], splitTime[1], splitTime[2]);
        return myDate.getTime();
    }

    function parseURLs($data) {
        var arr = [],
            urlsArr = [].concat($data.url);

        for (var i = 0, l = urlsArr.length; i < l; i++) {
            arr.push(new RealTimeHighlightsUrl(urlsArr[i]));
        }
        return arr;
    }

    function parseThumbs($data) {
        var arr = [],
            thumbs = (exists($data, "thumbnails.thumb")) ? $data.thumbnails.thumb : [];

        for (var i = 0, l = thumbs.length; i < l; i++) {
            arr.push({ type: thumbs[i].type, url:thumbs[i]._text });
        }

        return arr;
    }

    function getThumbByType($thumbnails, $type) {
        for (var i = 0; i < $thumbnails.length; i++) {
            if ($thumbnails[i].type.toString() === $type.toString()) {
                return $thumbnails[i];
            }
        }
    }

    function getURLfromScenarios($urls, $scenario) {
        for (var i = 0, l = $urls.l; i < l; i++) {
            if ($urls[i].playback_scenario == $scenario){
                return $urls[i];
            }
        }

        return null;
    }

    function establishDefaultURL($urls, $scenarios) { // $scenarios === array of scenarios in order of priority
        for (var i = 0, l = $scenarios.length; i < l; i++) {
            var scenario = getURLfromScenarios($urls, $scenarios[i]);

            if (exists(scenario)){
                return scenario; //rawr rawr like a dungeon dragon
            }
        }

        // you lose.
        return null;
    }

	return Highlight;
});
